export const STRATEGY_DRAFT_STORAGE_KEY = "strategy-draft";

export function clearStrategyDraftStorage(): void {
  try {
    sessionStorage.removeItem(STRATEGY_DRAFT_STORAGE_KEY);
  } catch {
    // Storage cleanup is best effort.
  }
}
